module.exports = __webpack_public_path__ + "img/in-progress-private.3e7c05a1.png";